module.exports = __webpack_public_path__ + "img/bernabeu.7b81c32e.png";